__turbopack_context__.v({
  "container": "Chpygq_container",
  "content": "Chpygq_content",
  "contentSwipable": "Chpygq_contentSwipable",
  "swipableContantContainer": "Chpygq_swipableContantContainer",
});
